import { render, staticRenderFns } from "./ContractCatalog.vue?vue&type=template&id=01008b1b"
import script from "./ContractCatalog.vue?vue&type=script&lang=js"
export * from "./ContractCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports